/** Check if a response is http error response. */
export const isErrorResponse = response => response.status >= 400;
